import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const ShortFormTooltip = (props: any) => {
  const { setShortFormTooltip } = props
  const { t } = useTranslation()

  const handleModal = () => {
    setShortFormTooltip((prev: boolean) => !prev)
  }

  const handleMoveLink = (url: string) => {
    if (url) {
      window.open(url, '_blank')
    }
  }

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white    absolute border-[3px] border-main  rounded-[20px] ',
        {
          'w-[330px] top-0 left-0 z-50': !isMobile,
          'w-[280px] bottom-5 -left-32': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex justify-between items-center">
        <span className="font-bold text-[18px]">{t('productVideoEditor.shortFormTooltip.title')}</span>
        <button className="" type="button" onClick={handleModal}>
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </p>
      <p className="text-left">
        {t('productVideoEditor.shortFormTooltip.description')}
      </p>

      <p
        className="flex gap-2  text-[14px] items-center cursor-pointer"
        onClick={() => {
          handleMoveLink('https://solution.fastseller.shop/termofuse')
        }}
      >
        <span className="text-href  ">{t('productVideoEditor.shortFormTooltip.viewFullTerms')} {`>`}</span>{' '}
      </p>
    </div>
  )
}
